<template>
  <v-autocomplete
    auto-select-first
    outlined
    class="font-weight-bold ACMB_for_testing"
    prepend-inner-icon="mdi-folder-outline"
    :items="$store.getters.folder_tree"
    item-text="label"
    item-value="id"
    hide-details
    return-object
    label="Folder"
    :search-input.sync="search"
    :filter="customFilter"
    v-model="selected"
    v-bind="$attrs"
  >
    <template v-slot:item="{ item }">
      <div class="px-0 w-full">
        <v-list-item
          :style="{
            paddingLeft: item.hierarchy_level * 20 + 'px',
          }"
          :class="{
            'contents-hidden': item.hidden_parent && !$store.state.lock.unlocked,
          }"
        >
          <v-list-item-icon class="mr-2 ml-1">
            <v-icon color="primary">{{
              item.hidden_parent ? "mdi-folder-lock" : "mdi-folder"
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-html="$options.filters.highlight(item.label, highlight_regex)"
              :title="item.label"
              class="font-weight-bold lockableTextField"
            ></v-list-item-title>
            <v-list-item-subtitle
              class="primary--text text-caption"
              v-if="showItemLocationsCondition"
            >
              <v-icon color="primary" x-small>mdi-map-marker</v-icon>
              <span
                v-html="$options.filters.highlight(item.search_string, highlight_regex)"
                :title="item.search_string"
                class="lockableTextField"
              ></span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="item.favorite">
            <v-icon color="primary">mdi-star</v-icon>
          </v-list-item-action>
        </v-list-item>
      </div>
    </template>
    <template v-slot:selection="{ item }">
      <div
        :class="{
          'contents-hidden': item.hidden_parent && !$store.state.lock.unlocked,
        }"
      >
        <span class="lockableTextField">{{ item.label }}</span>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "ParentSelector",
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    showItemLocationsCondition() {
      return (
        this.search &&
        this.search != "" &&
        this.search != "Home" &&
        !this.$store.getters.folder_tree.find(
          (v) => v.label.toLowerCase() == this.search.toLowerCase()
        )
      );
    },
    highlight_regex() {
      if (!this.search || this.search == "") {
        return "";
      } else {
        let search = this.search.trim();
        let regex_pattern = `(${search.split(/\s+/).join("|")})`;
        return regex_pattern;
      }
    },
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const item_i = item.search_string.toLowerCase();
      const search_i = queryText.toLowerCase();
      return item_i.indexOf(search_i) > -1;
    },
  },
};
</script>
